module.exports = __webpack_public_path__ + "img/maas_wrapbg1.125355b8.png";